import React from 'react';
import { Trash2 } from 'lucide-react';

/* ONE BIN FOR THE WHOLE SHEET, AND ONE CLICK — Max, 2026-10-08: "click xóa thì xóa luôn chứ".

   IT ASKED FIRST FOR AN AFTERNOON, and the reasoning is kept here because it is the thing that was
   weighed rather than forgotten: a row can carry an owner, a date and an answer, and a masterplan
   row cannot be retyped from memory. Max then used it on a line he had just added himself, where
   a confirmation is a second click for a row that is two seconds old. He is the one deleting
   things, so one click it is, and the same click everywhere — a bin that asks on one table and
   fires on the next is the page teaching two rules, which is what the shared component exists to
   stop.

   WHAT THE WAY BACK ACTUALLY IS, now that nothing stands in front of the delete:
     * a MASTERPLAN row (`from_doc`) comes back by re-running its seed, which is where its wording
       lives — that is what the hover says, and it is the only honest reassurance available;
     * a row somebody typed has no way back, and that is the cost of this decision. An undo would
       be the thing to build if it ever bites.

   The TITLE still distinguishes the two, because the hover is now the only place a person can be
   told which kind of row they are about to remove. */
export default function GtmBin({ t, busy, onRemove, fromDoc = false, label }) {
  const why = fromDoc ? t('gtm.removeDocWhy') : (label || t('gtm.remove'));
  return (
    <button type="button" className="gtm-bin" disabled={busy}
      title={why} aria-label={label || t('gtm.remove')}
      onClick={onRemove}>
      <Trash2 size={13} />
    </button>
  );
}
